<template>
  <el-container>
    <el-header>
      <div class="header-container">
        <div class="header-content">
          <div class="logo-group">
            <img src="@/assets/images/logo.png" alt="公司Logo" class="logo" />
            <h1 class="company-name">河南郑大水利科技有限公司</h1>
          </div>
          <div class="header-right"></div>
        </div>
      </div>
    </el-header>
    <el-main>
      <div class="menu-container">
        <el-menu
          :default-active="activeIndex"
          class="full-width-menu"
          mode="horizontal"
          background-color="#ededed"
          text-color="#333"
          active-text-color="#409EFF"
          :router="true"
          @select="handleSelect"
        >
          <el-menu-item index="/homePages">首页</el-menu-item>
          <el-menu-item index="/about">关于我们</el-menu-item>
          <el-menu-item index="/myServices">业务范围</el-menu-item>
          <el-menu-item index="/myCases">工程案例</el-menu-item>
          <el-menu-item index="/myContact">联系我们</el-menu-item>
        </el-menu>
        <!-- 添加路由视图 -->
        <router-view></router-view>
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      activeIndex: this.$route.path, // 默认激活当前路由对应的菜单项,
    };
  },
  watch: {
    // 监听路由变化，更新菜单激活状态
    $route(to) {
      this.activeIndex = to.path;
    },
  },
  methods: {
    handleSelect(key) {
      this.activeIndex = key;
      console.log(key);
    },
  },
};
</script>
<style >
/* 全局样式重置 */
body,
html {
  margin: 0;
  padding: 0;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    Arial, sans-serif;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
</style>

<style scoped>
/* 布局容器样式 */
.el-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 头部样式 */
.el-header {
  --header-height: 80px;
  height: var(--header-height) !important;
  padding: 0 !important;
  background-color: rgba(64, 158, 255, 0.8);
  color: white;
}

.header-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}

.header-content {
  width: 1200px;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-group {
  display: flex;
  align-items: center;
  gap: 20px;
}

.logo {
  height: 60px;
  width: 60px;
  border-radius: 8px;
  object-fit: contain;
}

.company-name {
  margin: 0;
  font-size: 24px;
  font-weight: normal;
  white-space: nowrap;
}

/* 主体内容区样式 */
.el-main {
  --header-height: 80px;
  height: calc(100vh - var(--header-height)) !important;
  padding: 0 !important;
  margin: 0 !important; /* 确保没有外边距 */
  flex: 1; /* 填充剩余空间 */
  display: flex;
  flex-direction: column; /* 改为垂直布局 */
  background-color: #ededed;
}

.menu-container {
  width: 1200px;
  height: 60px;
  margin: 0 auto; /* 新增：水平居中保障 */
}

/* 菜单栏样式 */
.full-width-menu {
  width: 100%;
  display: flex;
}

.full-width-menu > * {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.full-width-menu .el-submenu {
  display: flex;
}

.full-width-menu .el-submenu__title {
  flex: 1;
  justify-content: center;
}

/* 响应式设计 */
@media (max-width: 1240px) {
  .header-content,
  .menu-container {
    width: 95%;
    padding: 0 20px;
  }

  .company-name {
    font-size: 20px;
  }
}

@media (max-width: 768px) {
  .company-name {
    font-size: 18px;
  }

  .logo {
    height: 50px;
    width: 50px;
  }
}
</style>